import { FC } from "react";
import { usePaymentCurrency } from "@hooks/selectors/panel.selectors";
import { useDonateBonusContext } from "./context";
import { Text } from '@constructor/components';

const DonateBonusThreshold: FC = (props) => {

    const bonus = useDonateBonusContext()
    const currency = usePaymentCurrency();

    if(!bonus){
        return null;
    }

    const replaces = {
        currency,
        bonus_threshold: bonus.threshold
    }

    return (
        <Text text={`${bonus.threshold} ${currency}`} {...props} replaces={replaces} />
    )
    
}

export default DonateBonusThreshold;